import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: 'pc-hot-goods',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '热卖商品',
          icon: 'el-icon-goods',
          content: {
            topList: [{
              label: '实时低价热卖榜',
              goods_select: []
            }]
          },
          config: [{
            label: '分组数据',
            name: 'topList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              goods_select: {
                label: '商品数据',
                value: []
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      goods: [[]]
    };
  },
  computed: {},
  created: function created() {
    var _this = this;
    this.widgets.content.topList.forEach(function (item, index) {
      _this.getItem(index);
    });
  },
  mounted: function mounted() {},
  methods: {
    getItem: function getItem() {
      var _this2 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'topList';
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'goods';
      if (this.widgets.content[source].length) {
        var idList = this.widgets.content[source][index].goods_select;
        if (idList && idList.length) {
          this.apiPost('/bbb/goodsInfo/listData', {
            idList: idList,
            sortByParamId: true
          }).then(function (res) {
            var jsonArray = res.data;
            _this2.$set(_this2[target], index, jsonArray);
          });
        }
      }
    },
    handleLink: function handleLink(item) {
      var activeId = item.marketingGeneral.fullCutRuleList.map(function (item) {
        return item.ruleId;
      }).join(',');
      if (activeId) {
        this.addTrack('campaign_product_click', {
          userId: this.$store.state.userInfo.userId,
          goodsId: item.id,
          activeId: activeId,
          labelId: ''
        });
      }
    }
  }
};